import React from 'react';

import {Song} from '../../../../../types';
import {ResourceDetails} from '../ResourceDetails';

interface Props {
  id: string;
  name: string;
  curatorName: string;
  artwork: string;
  tracks: Song[];
  trackCount: number;
  likes: number;
  onPlay(): void;
}
export function PlaylistDetails(props: Props) {
  return (
    <>
      <ResourceDetails
        type="playlist"
        creatorName={props.curatorName}
        {...props}
      />
    </>
  );
}
